// extracted by mini-css-extract-plugin
export var dropdownContainer = "_mc-0";
export var leftAlign = "_mc-4";
export var listItem = "_mc-2";
export var listItemWrapper = "_mc-1";
export var operationText = "_mc-3";